import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Icon, Input, Radio, Modal } from 'antd';
import { emailRegex } from 'store/utility';
import { checkEmail } from 'store/actions/index';

const { Item } = Form;

class CreateAdminModal extends Component {
  state = { validationState: '' };

  onFormCancel = () => {
    // wrapping onCancel to clear form
    const { onCancel, form } = this.props;
    onCancel();
    setTimeout(() => {
      this.setState(prev => ({ ...prev, validationState: '' }));
      form.resetFields();
    }, 100);
  };

  checkEmailValidator = (rule, email, callback) => {
    this.setState(prev => ({ ...prev, validationState: 'validating' }));
    if (!email) {
      this.setState(prev => ({ ...prev, validationState: 'error' }));
      return callback('Input valid email!');
    }
    if (!email.match(emailRegex())) {
      this.setState(prev => ({ ...prev, validationState: 'error' }));
      return callback('The input is not a valid E-mail');
    }
    checkEmail(email)
      .then(resp => {
        const { valid } = resp.data;
        if (valid) {
          this.setState(prev => ({ ...prev, validationState: 'success' }));
          return callback();
        } else {
          this.setState(prev => ({ ...prev, validationState: 'error' }));
          return callback('Email already taken!');
        }
      })
      .catch(console.error);
  };

  render() {
    const { visible, onOk, form, loading } = this.props;
    const { getFieldDecorator } = form;
    const { validationState } = this.state;

    return (
      <Modal title="Create User" visible={visible} onCancel={this.onFormCancel} confirmLoading={loading} onOk={onOk}>
        <Form layout="vertical">
          <Item label="email" hasFeedback validateStatus={validationState} id={validationState}>
            {getFieldDecorator('email', {
              validate: [
                {
                  trigger: 'onBlur',
                  rules: [{ validator: this.checkEmailValidator }],
                },
              ],
            })(<Input prefix={<Icon type="mail" />} placeholder="Username" />)}
          </Item>
          <Item label="password">
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Input valid password!' }],
            })(<Input prefix={<Icon type="lock" />} type="password" placeholder="Password" />)}
          </Item>
          <Item>
            {getFieldDecorator('role', {
              initialValue: 'SALES',
            })(
              <Radio.Group>
                <Radio value="SALES">Sales</Radio>
                <Radio value="STOCK">Stock</Radio>
              </Radio.Group>,
            )}
          </Item>
        </Form>
      </Modal>
    );
  }
}

CreateAdminModal.proptypes = {
  onOk: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

const ModalForm = Form.create()(CreateAdminModal);

export default ModalForm;



// WEBPACK FOOTER //
// ./src/components/Admin/SuperAdmin/CreateAdmin/CreateAdminModal.js